<template>
  <div class="ColoradoNotice">
    <h2 class="ColoradoNotice_Heading">
      PRIVACY NOTICE FOR COLORADO RESIDENTS
    </h2>

    <p>
      If you are a Colorado resident, you are provided with the following
      notification:
    </p>

    <p>
      <span class="ColoradoNotice_ItemTitle"
        >Sales and Targeted Advertising:</span
      >
      Grove Collaborative does not sell your personal information in exchange
      for monetary compensation. We do share your Personal Information for
      targeted advertising purposes as we describe in the Privacy Policy to make
      the Service available to you. For example, we may disclose information to
      advertising partners, advertising technology companies, and companies that
      perform advertising-related services in order to improve the relevance of
      our advertising and marketing. To the extent possible, Grove Collaborative
      excludes Personal Information from Colorado residents from these
      activities.
    </p>

    <p>
      <span class="ColoradoNotice_ItemTitle">Profiling:</span>
      To the extent we engage in automated processing or profiling to prevent,
      detect, protect against or respond to fraudulent or unlawful activity, we
      are not required to offer the right to opt out. We otherwise do not engage
      in profiling that requires an opt-out as defined under the CPA.
    </p>

    <p>
      If you are a resident of Colorado and wish to exercise any of your rights
      under the CPA, you or your authorized agent may make a request to confirm,
      access, correct, delete, obtain a copy, or opt-out of the processing of
      your Personal Information for targeting advertising by submitting a
      Privacy Request Form
      <SkyLink
        inline
        to="https://preferences.grove.co/privacy"
        target="_blank"
        tag="a"
        >here</SkyLink
      >, or by emailing
      <SkyLink inline to="mailto:support@grove.co" tag="a"
        >support@grove.co.</SkyLink
      >
      Please indicate that you are making a request pursuant to your “Colorado
      Privacy Rights” and provide us with the requested information to verify
      your request. We will take steps to verify your request by matching the
      information provided by you with the information we have in our records.
    </p>
  </div>
</template>

<style lang="scss">
.ColoradoNotice {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
    text-align: center;
  }

  &_ItemTitle {
    text-decoration: underline;
  }
}
</style>
